import { Button, Modal, ModalContent, ModalFooter } from "monday-ui-react-core"

const UploadReceiverDetailsErrorModal = ({showModal, closeModal, csvErrors}) => {
    return (
        <Modal
            id="errors-modal"
            onClose={closeModal}
            show={showModal}
            title={'File could not be uploaded'}
        >
            <ModalContent>
                <p className='fw-bold'>Please fix the following errors in the file and upload it again.</p>
                <div className='error-container'>
                    {
                        csvErrors.length && csvErrors.map((csv, i) => {
                            let rowNumber = csv?.rowNumber != null && csv?.rowNumber !== "" ?
                                <p>Row Number: {csv.rowNumber}</p>
                                : ""
                            let sourceNumber = csv?.sourceNumber !== null && csv?.sourceNumber !== "" ?
                                <p>Source Number: {csv.sourceNumber}</p>
                                : ""
                            let error = csv?.error != null && csv?.error !== "" ?
                                <p>Error: {csv.error}</p>
                                : ""

                            return (
                                <div className='error-item' key={i}>
                                    {rowNumber}
                                    {sourceNumber}
                                    {error}
                                </div>
                            )
                        })         
                    }
                </div>
            </ModalContent>
            <ModalFooter>
                <div className="d-flex justify-content-end align-items-center">
                    <Button
                        onClick={closeModal}
                        className="cancel-modal-button"
                    >
                        Close
                    </Button>
                </div>
            </ModalFooter>
        </Modal>
    )
}

export default UploadReceiverDetailsErrorModal